"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namedErrorContainer = void 0;
// wraps rejection result into { [name]: error } object
function namedErrorContainer(name, promiseFunction) {
    return () => promiseFunction().catch((error) => {
        // throw object is a bad practice, but this should be breaking change
        throw { [name]: error };
    });
}
exports.namedErrorContainer = namedErrorContainer;
//# sourceMappingURL=namedErrorContainer.js.map